var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{attrs:{"type":"textarea","value":_vm.value,"placeholder":_vm.placeholder,"rows":_vm.rows,"disabled":_vm.disabled,"custom-class":_vm.customClass + ' tw-font-mono'},on:{"input":_vm.handleInput,"blur":_vm.validateJson}})}
var staticRenderFns = []

export { render, staticRenderFns }